import { render, staticRenderFns } from "./AbandonedSummary.vue?vue&type=template&id=2c78313e"
import script from "./AbandonedSummary.vue?vue&type=script&lang=js"
export * from "./AbandonedSummary.vue?vue&type=script&lang=js"
import style0 from "./AbandonedSummary.vue?vue&type=style&index=0&id=2c78313e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports